export const ScheduleData = [
	{
		label: "Technical Event",
		title: "Technical Event",
		date: "Tuesday, 11 April 2023",
		time: "10:30 - 16.00",
		thumbnail: require("../assets/images/lighweight-ml.png").default,
		celendar_url:
			"https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=M2Vzc3B2ZWlzOG44azI0bDhiYTgwNDE4NWQgdHJpZ2dlcjJrMjNAbQ&tmsrc=trigger2k23%40gmail.com",
		youtube_url: "",
		agenda: [
			{
				time: "09.00 - 10.30",
				timezone: "UTC/GMT +5:30 hours",
				title: "Event Inaguration",
			 	speaker: "Venue: A. P. J. Abdul Kalam Seminar Hall",

			},
			{
				time: "10.30 - 11.30",
				timezone: "UTC/GMT +5:30 hours",
				title: "Paper Presentation",
				topic: "Faculty Co-ordinators: Dr. Kamal Raj T",
				speaker: "Co-ordinators: Keerthana R, Meghana S, Madhusalini",
				url: "https://forms.gle/7YBN8TyWUWjkR15A9"
			},
			{
				time: "10.30 - 15.00",
				timezone: "UTC/GMT +5:30 hours",
				title: "CodeX",
				topic: "Faculty Co-ordinators: Prof. Autin jose ",
				speaker: "Co-ordinators: Shibin C Reji, Shankarling, Sanskar Drolia, Santosh K",
				url: "https://forms.gle/G9r2YNorL5c23N887"
			},
			{
				time: "10.30 - 12.30",
				timezone: "UTC/GMT +5:30 hours",
				title: "Pixel Wizard",
				topic: "Faculty Co-ordinators: Prof. Manasa G.V.K ",
				speaker: "Co-ordinators: Sneha Aparna, Samyuktha R, Samyuktha S, Sneha N.V",
				url: "https://forms.gle/A6ZybiTmjSHPZiz46"
			},
			{
				time: "11.30 - 12.30",
				timezone: "UTC/GMT +5:30 hours",
				title: "Technical Quiz",
				topic: "Faculty Co-ordinators: Dr. Kiruba ",
				speaker: "Co-ordinators: Rohan R, Vijay Rangan",
				url: "https://forms.gle/4yg1fEJfNuQDQ1yX8"
			},
			{
				time: "16:00",
				timezone: "UTC/GMT +5:30 hours",
				title: "Event closing",
			},
		],
	},
	{
		label: "Non-Technical Event",
		title: "Non-Technical Event",
		date: "Tuesday, 11 April 2023",
		thumbnail: require("../assets/images/lighweight-android.png").default,
		time: "10:30 - 16.00",
		celendar_url:
			"https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=M2Vzc3B2ZWlzOG44azI0bDhiYTgwNDE4NWQgdHJpZ2dlcjJrMjNAbQ&tmsrc=trigger2k23%40gmail.com",
		youtube_url: "",
		agenda: [
			{
				time: "09.00 - 10.30",
				timezone: "UTC/GMT +5:30 hours",
				title: "Event Inaguration",
				speaker: "Venue: A. P. J. Abdul Kalam Seminar Hall",
			},
			{
				time: "10.30 - 12.00",
				timezone: "UTC/GMT +5:30 hours",
				title: "Cooking Without Fire",
				topic: "Faculty Co-ordinators: Prof. Sunil",
				speaker: "Co-ordinators: Deekshitha UM, Gunashree, Keerthana HS ",
				url: "https://forms.gle/4QbtqxA9crW9tSTz8"
			},
			{
				time: "10.30 - 15.30",
				timezone: "UTC/GMT +5:30 hours",
				title: "Treasure Hunt",
				topic: "Faculty Co-ordinators: Prof. Deepa kannur ",
				speaker: "Co-ordinators: Santhosh N, Simple.KS, Srivalli N, Hemavathi R ",
				url: "https://forms.gle/XGDQZG2GVxoWE1737"
			},
			{
				time: "11.00 - 12.30",
				timezone: "UTC/GMT +5:30 hours",
				title: "Golden Minute",
				topic: "Faculty Co-ordinators: Prof. porkodi",
				speaker: "Co-ordinators: Alisha, Manasi, Jeevan",
				url: "https://forms.gle/Lz9EZ2yM1bNzi6eS7"
			},
			{
				time: "11.30 - 12.30",
				timezone: "UTC/GMT +5:30 hours",
				title: "Bakasura",
				topic: "Faculty Co-ordinators: Prof. Rashmi BR",
				speaker: "Co-ordinators: Shyam Sundar",
				url: "https://forms.gle/qych3UZ5WVPg7tCd8"
			},
			{
				time: "13.00 - 15.30",
				timezone: "UTC/GMT +5:30 hours",
				title: "BGMI",
				topic: "Faculty Co-ordinators: Prof. Supraja ",
				speaker: "Co-ordinators: Amogha L A, Shri Hari, Adithya J",
				url: "https://forms.gle/3XLSqnowg1J8tyTH9"
			},
			{
				time: "14.00 - 15.30",
				timezone: "UTC/GMT +5:30 hours",
				title: "Shout in Silence",
				topic: "Faculty Co-ordinators: Prof. Rajkumar",
				speaker: "Co-ordinators: Shobha, Shristi J, Sahana Raja ",
				url: "https://forms.gle/s95t7UcH12dGYcCR7"
			},
			{
				time: "16:00",
				timezone: "UTC/GMT +5:30 hours",
				title: "Event closing",
			},
		],
	},
	{
		label: "Sports",
		title: "Sports",
		date: "Tuesday, 11 April 2023",
		time: "10:30 - 16.00",
		thumbnail: require("../assets/images/lighweight-web.png").default,
		celendar_url:
			"https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=M2Vzc3B2ZWlzOG44azI0bDhiYTgwNDE4NWQgdHJpZ2dlcjJrMjNAbQ&tmsrc=trigger2k23%40gmail.com",
		youtube_url: "",
		agenda: [
			{
				time: "09.00 - 10.30",
				timezone: "UTC/GMT +5:30 hours",
				title: "Event Inaguration",
				speaker: "Venue: A. P. J. Abdul Kalam Seminar Hall",
			},
			{
				time: "10.30 - 12.00",
				timezone: "UTC/GMT +5:30 hours",
				title: "Mini - Cricket ",
				topic: "Faculty Co-ordinators: Prof. Shashidar",
				speaker: "Co-ordinators: Rahul Rai, Mareddy Crishtopher, Manoj J",
				url: "https://forms.gle/C4ynVtPDnqNxaXw88"
			},
			{
				time: "10.30 - 12.00",
				timezone: "UTC/GMT +5:30 hours",
				title: "Mini-VolleyBall ",
				topic: "Faculty Co-ordinators: Prof. Siddik",
				speaker: "Co-ordinators: Nagaprasad, Niranjan R ",
				url: "https://forms.gle/KRDcg1JpM5Pgvsif9"
			},
			{
				time: "16:00",
				timezone: "UTC/GMT +5:30 hours",
				title: "Event closing",
			},
		],
	},
];
